<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="400" content-class="rounded-lg" scrollable
			@keydown.esc="dialog = false">
			<v-card>
				<v-card-title class="h6">
					<span class="black--text text-uppercase font-weight-bold">Ubah Email</span>
					<v-spacer></v-spacer>
					<v-btn text small color="pink" class="mr-n4" @click="modalHide">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pb-0">
					<v-form ref="formChangeMobilephone" role="form" @submit.prevent="save">
						<v-row align="center" justify="center">
							<v-col cols="12">
								<div>
									<div class="text-body-1 font-weight-bold pb-1">Email Baru</div>
									<v-text-field autocomplete="false" outlined dense v-model="email" hide-details="auto"
										@focus="() => responseError.email = ''" :error-messages="responseError.email"
										:rules="rules.email" validate-on-blur></v-text-field>
								</div>
							</v-col>
							<v-col cols="12">
								<div>
									<div class="text-body-1 font-weight-bold pb-1">Password</div>
									<v-text-field autocomplete="false" outlined dense v-model="password" :type="typeInput"
										:append-icon="icon" @click:append="showPassword" hide-details="auto"
										@focus="() => responseError.password = ''" :error-messages="responseError.password"
										validate-on-blur :rules="rules.password"></v-text-field>
								</div>
							</v-col>
						</v-row>
					</v-form>
					<v-row>
						<v-col cols="12" class="text-center">
							<v-btn depressed color="primary" large
								class="text-capitalize font-weight-bold text-body-2 rounded-lg" @click="save">Simpan</v-btn>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
	data() {
		return {
			dialog: false,
			email: '',
			password: '',
			typeInput: 'password',
			icon: 'mdi-eye',
			rules: {
				email: [
					v => !!v || 'Tidak boleh kosong',
				],
				password: [
					v => !!v || 'Tidak boleh kosong',
				],
			},
		}
	},
	computed: {
		...mapState('profile', ['responseError']),
	},
	methods: {
		...mapMutations('profile', ['validationError']),

		async validatePaste(val) {
			let pasted = await val.clipboardData.getData('text')
			setTimeout(() => {
				// if (!parseInt(pasted)) {
				// 	this.mobilephone = ''
				// }
			})
		},
		showPassword() {
			this.typeInput = this.typeInput == 'text' ? 'password' : 'text'
			this.icon = this.icon == 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye'
		},
		modalShow() {
			this.dialog = true
			this.validationError({})
			this.email = ''
			this.password = ''
		},
		modalHide() {
			this.dialog = false
		},
		save() {
			if (this.$refs.formChangeMobilephone.validate()) {
				let params = {
					email: this.email,
					password: this.password
				}
				this.$emit('action', params)
			}
		},
	},
};
</script>